import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  isPlatformBrowser,
  isPlatformServer,
  NgClass,
} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontSizeService } from '../../../services/font-size.service';
import { AccessabilityFontSize } from '../../../models/accessibility-font-sizes.model';
import { distinctUntilChanged, fromEvent, skip, Subscription } from 'rxjs';
import { ChatStateService } from '../../../services/chat-state.service';
import { BhashiniLanguageTranslationComponent } from '../../utility/bhashini-language-translation/bhashini-language-translation.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CachingService } from '../../../services/caching.service';
@Component({
  selector: 'app-accessibility-nav',
  standalone: true,
  imports: [NgClass, FormsModule,BhashiniLanguageTranslationComponent],
  templateUrl: './accessibility-nav.component.html',
  styleUrl: './accessibility-nav.component.scss',
})
export class AccessibilityNavComponent
  implements OnInit, AfterViewInit, OnDestroy {
  currentFontSize: AccessabilityFontSize = AccessabilityFontSize.normal;
  isBrowser!: boolean;
  isAccessibilityOpen = false;
  readonly accessibiltyFontSizes = AccessabilityFontSize;

  @ViewChild('navBarStrip') navBarStripRef!: ElementRef;

  private scrollSubs?: Subscription;

  /** Right margin applied to this strip so it shrinks on desktop when the chat dock opens. */
  navChatDockMargin = 0;
  private dockOpenSub!: Subscription;
  private dockWidthSub!: Subscription;
  private isChatDockOpen = false;
  renderAccesibilityContent = true;
  private readonly destroyRef = inject(DestroyRef);
  constructor(
    private fontSizeService: FontSizeService,
    @Inject(PLATFORM_ID) public platformId: string,
    private renderer: Renderer2,
    private chatState: ChatStateService,
    private cachingService: CachingService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (!this.isBrowser) {
      return;
    }
    this.currentFontSize = this.fontSizeService.getCurretSize();
    this.onFontSizeSelect(this.currentFontSize || AccessabilityFontSize.normal);
    this.subscribeToLanguageChange();


    this.dockOpenSub = this.chatState.isDockOpen$.subscribe((open) => {
      this.isChatDockOpen = open;
      this.updateNavChatDockMargin();
    });
    this.dockWidthSub = this.chatState.dockWidth$.subscribe(() => {
      this.updateNavChatDockMargin();
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateNavChatDockMargin();
  }

  private updateNavChatDockMargin(): void {
    const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 992;
    this.navChatDockMargin =
      this.isChatDockOpen && this.chatState.dockWidth && isDesktop
        ? this.chatState.dockWidth
        : 0;
    this.subscribeToLanguageChange();
  }

  ngAfterViewInit(): void {
    this.initScrollListener();
  }
  private initScrollListener() {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    this.scrollSubs = fromEvent(window, 'scroll').subscribe({
      next: () => {
        if (window.scrollY > 10) {
          document.querySelectorAll('.header-margin').forEach((element) => {
            element.classList.add('navbar-margin');
          });
          this.renderer.addClass(this.navBarStripRef.nativeElement, 'hidden');
          this.renderer.removeClass(
            this.navBarStripRef.nativeElement,
            'visible'
          );
          return;
        }
        this.renderer.addClass(this.navBarStripRef.nativeElement, 'visible');
        this.renderer.removeClass(this.navBarStripRef.nativeElement, 'hidden');
        document.querySelectorAll('.header-margin').forEach((element) => {
          element.classList.remove('navbar-margin');
        });
      },
    });
  }

  onAccessibilityClick() {
    this.isAccessibilityOpen = true;
  }

  onFontSizeSelect(toUpdateSize: AccessabilityFontSize) {
    this.fontSizeService.updateSize(toUpdateSize);
    this.currentFontSize = toUpdateSize;
  }

  closeMain() {
    this.isAccessibilityOpen = false;
  }
  private subscribeToLanguageChange(): void {
    this.cachingService.languageChange$
      .pipe(
        skip(1),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.refreshAppContent();
      });
  }
  private refreshAppContent(): void {
    this.renderAccesibilityContent = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.renderAccesibilityContent = true;
      this.cdr.detectChanges();
    });
  }
  ngOnDestroy() {
    this.scrollSubs?.unsubscribe();
    this.dockOpenSub?.unsubscribe();
    this.dockWidthSub?.unsubscribe();
  }
}
